export const RHYTHM_LINE_COMPOSE_SYMBOLS = [
  { id: "whole_note", label: "Whole note", duration: 4, width: 34 },
  { id: "dotted_half_note", label: "Dotted half note", duration: 3, width: 34 },
  { id: "half_note", label: "Half note", duration: 2, width: 28 },
  { id: "dotted_quarter_note", label: "Dotted quarter note", duration: 1.5, width: 32 },
  { id: "quarter_note", label: "Quarter note", duration: 1, width: 26 },
  { id: "dotted_eighth_note", label: "Dotted eighth note", duration: 0.75, width: 30 },
  { id: "eighth_note", label: "Eighth note", duration: 0.5, width: 24 },
  { id: "sixteenth_note", label: "Sixteenth note", duration: 0.25, width: 24 },
  { id: "thirty_second_note", label: "Thirty-second note", duration: 0.125, width: 24 },

  { id: "eighth_pair", label: "2 eighths", duration: 1, width: 38, countPattern: [0.5, 0.5] },
  { id: "eighth_four", label: "4 eighths", duration: 2, width: 72, countPattern: [0.5, 0.5, 0.5, 0.5] },
  { id: "sixteenth_sixteenth_eighth", label: "2 sixteenths + eighth", duration: 1, width: 52, countPattern: [0.25, 0.25, 0.5] },
  { id: "eighth_sixteenth_sixteenth", label: "Eighth + 2 sixteenths", duration: 1, width: 52, countPattern: [0.5, 0.25, 0.25] },
  { id: "sixteenth_four", label: "4 sixteenths", duration: 1, width: 64, countPattern: [0.25, 0.25, 0.25, 0.25] },
  { id: "dotted_quarter_tied_eighth", label: "Dotted quarter tied to eighth", duration: 2, width: 70 },

  { id: "1e1e1e", label: "3 beamed eighths", duration: 1.5, width: 72, countPattern: [0.5, 0.5, 0.5] },
  { id: "2s1e1e", label: "2 sixteenths + 2 eighths", duration: 1.5, width: 82, countPattern: [0.25, 0.25, 0.5, 0.5] },
  { id: "1e2s1e", label: "Eighth + 2 sixteenths + eighth", duration: 1.5, width: 82, countPattern: [0.5, 0.25, 0.25, 0.5] },
  { id: "1e1e2s", label: "2 eighths + 2 sixteenths", duration: 1.5, width: 82, countPattern: [0.5, 0.5, 0.25, 0.25] },
  { id: "2s2s1e", label: "4 sixteenths + eighth", duration: 1.5, width: 92, countPattern: [0.25, 0.25, 0.25, 0.25, 0.5] },
  { id: "2s1e2s", label: "2 sixteenths + eighth + 2 sixteenths", duration: 1.5, width: 92, countPattern: [0.25, 0.25, 0.5, 0.25, 0.25] },
  { id: "1e2s2s", label: "Eighth + 4 sixteenths", duration: 1.5, width: 92, countPattern: [0.5, 0.25, 0.25, 0.25, 0.25] },
  { id: "2s2s2s", label: "6 sixteenths", duration: 1.5, width: 102, countPattern: [0.25, 0.25, 0.25, 0.25, 0.25, 0.25] },

  { id: "whole_rest", label: "Whole rest", duration: 4, width: 30 },
  { id: "half_rest", label: "Half rest", duration: 2, width: 26 },
  { id: "quarter_rest", label: "Quarter rest", duration: 1, width: 26 },
  { id: "eighth_rest", label: "Eighth rest", duration: 0.5, width: 26 },
  { id: "sixteenth_rest", label: "Sixteenth rest", duration: 0.25, width: 26 },
  { id: "thirty_second_rest", label: "Thirty-second rest", duration: 0.125, width: 28 }
];


export const RHYTHM_LINE_BEAMING_SYMBOLS = RHYTHM_LINE_COMPOSE_SYMBOLS.filter((symbol) => [
  "whole_note",
  "dotted_half_note",
  "half_note",
  "dotted_quarter_note",
  "quarter_note",
  "dotted_eighth_note",
  "eighth_note",
  "sixteenth_note",
  "thirty_second_note",
  "whole_rest",
  "half_rest",
  "quarter_rest",
  "eighth_rest",
  "sixteenth_rest",
  "thirty_second_rest"
].includes(symbol.id));

const SYMBOL_MAP = new Map(RHYTHM_LINE_COMPOSE_SYMBOLS.map((symbol) => [symbol.id, symbol]));

export function rhythmComposeSymbolInfo(symbol) {
  return SYMBOL_MAP.get(symbol) || null;
}

export function rhythmComposeDuration(symbol) {
  return rhythmComposeSymbolInfo(symbol)?.duration ?? null;
}

export function rhythmComposeWidth(symbol) {
  return rhythmComposeSymbolInfo(symbol)?.width ?? 28;
}

export function rhythmComposeLabel(symbol) {
  return rhythmComposeSymbolInfo(symbol)?.label || String(symbol || "").replaceAll("_", " ");
}

export function rhythmComposeCountPattern(symbol) {
  const pattern = rhythmComposeSymbolInfo(symbol)?.countPattern;
  return Array.isArray(pattern) ? pattern : null;
}
